import React from 'react';
import { Star } from '@phosphor-icons/react';
import { Badge } from '../ui/badge';

/**
 * One clickable record card in the merge grid. Selecting it makes that
 * record the "primary" (kept after merge); the others become duplicates.
 */
const RecordCard = ({ record, isPrimary, displayFields, onSelect }) => (
  <div
    onClick={() => onSelect(record.id)}
    className={`border-2 rounded-lg p-4 cursor-pointer transition-all ${
      isPrimary
        ? 'border-indigo-500 bg-indigo-50 ring-2 ring-indigo-200'
        : 'border-slate-200 hover:border-slate-300'
    }`}
    data-testid={`merge-select-${record.id}`}
  >
    <div className="flex items-center justify-between mb-3">
      <span className="font-semibold text-slate-800">
        {record.first_name} {record.last_name}
      </span>
      {isPrimary && (
        <Badge className="bg-indigo-600 text-white text-xs">
          <Star size={10} weight="fill" className="mr-1" /> Primary
        </Badge>
      )}
    </div>
    <div className="space-y-1.5">
      {displayFields.slice(2, 8).map(({ key, label }) => (
        <div key={key} className="flex justify-between text-xs">
          <span className="text-slate-500">{label}</span>
          <span className={`font-mono ${record[key] ? 'text-slate-800' : 'text-slate-300 italic'}`}>
            {record[key] || 'empty'}
          </span>
        </div>
      ))}
    </div>
    <p className="text-xs text-slate-400 mt-2 font-mono truncate">
      ID: {record.id.slice(0, 8)}...
    </p>
  </div>
);

export default RecordCard;
